import { createSelector } from 'reselect';
import { getSelectedLayout } from '../../utilities/get-selected-layout.esm.js';

var createDisplayLayoutSelector = function createDisplayLayoutSelector() {
  return createSelector(function (props) {
    return props.displayLayouts;
  }, getSelectedLayout);
};

export { createDisplayLayoutSelector };
//# sourceMappingURL=display-layout-selector.esm.js.map
